class TappiPersonalization extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.toggle = this.querySelector('[data-personalization-toggle]');
    this.field = this.querySelector('[data-personalization-field]');
    this.input = this.querySelector('[data-personalization-input]');
    this.counter = this.querySelector('[data-character-count]');

    if (!this.toggle || !this.field || !this.input || !this.counter) return;

    this.toggle.addEventListener('change', this.handleToggle);
    this.input.addEventListener('input', this.handleInput);
    this.closest('form')?.addEventListener('reset', this.handleReset);
    this.sync();
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('change', this.handleToggle);
    this.input?.removeEventListener('input', this.handleInput);
    this.closest('form')?.removeEventListener('reset', this.handleReset);
  }

  handleToggle = () => {
    this.sync();
    if (this.toggle.checked) this.input.focus();
  };

  handleInput = () => {
    this.counter.textContent = String(this.input.value.length);
  };

  handleReset = () => {
    requestAnimationFrame(() => this.sync());
  };

  sync() {
    const enabled = this.toggle.checked;
    this.field.hidden = !enabled;
    this.toggle.setAttribute('aria-expanded', String(enabled));
    this.input.disabled = !enabled;
    this.input.required = enabled;
    this.input.setAttribute('aria-required', String(enabled));

    if (!enabled) this.input.value = '';
    this.counter.textContent = String(this.input.value.length);
  }
}

if (!customElements.get('tappi-personalization')) {
  customElements.define('tappi-personalization', TappiPersonalization);
}
